import Cookies from 'js-cookie';

const signedInUserId = () => String(Cookies.get('userId') || '');

/**
 * Whether the signed-in user may act as the task's owner: the owner, or the
 * company's primary builder, who co-owns every management task in its
 * projects. The API decides and sends `viewerActsAsOwner`; comparing owner_id
 * is only for an API that does not send it yet.
 */
export function actsAsOwner(task) {
  if (!task) return false;
  if (typeof task.viewerActsAsOwner === 'boolean') return task.viewerActsAsOwner;
  const userId = signedInUserId();
  return !!userId && String(task.owner_id ?? '') === userId;
}

/**
 * Whether the signed-in user reviews this subtask, or the task itself: its
 * approver when it has one, otherwise the owner — and a co-owner, like the
 * owner. Mirrors the API's isReviewer.
 */
export function isTaskReviewer(task, subtask = null) {
  if (!task) return false;
  if (subtask?.approver_id) return String(subtask.approver_id) === signedInUserId();
  return actsAsOwner(task);
}
